import { mapState } from 'pinia';
import stores from 'store/modules';
import { get } from 'lodash';

export default {
    computed: {
        ...mapState(stores.User, ['userSettings']),
        ...mapState(stores.Organization, ['organizationSettings']),
    },

    methods: {
        /**
         * @param {String} featureKey
         * @param settingKey
         * @param defaultReturn
         * @param checkUserLevel
         * @returns {String | Boolean}
         */
        hasFeature(
            featureKey,
            settingKey = 'active',
            defaultReturn = false,
            checkUserLevel = true
        ) {
            if (checkUserLevel) {
                let userFeature = this.userSettings.find((f) => f.key === featureKey);

                if (userFeature && userFeature.settings[settingKey]) {
                    return true;
                }
            }

            let organizationFeature = this.organizationSettings.find((f) => f.key === featureKey);

            if (organizationFeature && organizationFeature.settings[settingKey]) {
                return true;
            }

            if (this.subscription) {
                return get(this.subscription.plan.features, featureKey, defaultReturn);
            }

            return false;
        },

        hasFeatureUser(featureKey, settingKey = 'active') {
            let userFeature = this.userSettings.find((f) => f.key === featureKey);

            return Boolean(userFeature && userFeature.settings[settingKey]);
        },
    },
};
